import {
  Component,
  OnInit,
  ElementRef,
  Input,
  Inject,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import * as Cesium from 'cesium';
import { Data } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { OPERATORS, RF_RADIUS } from 'src/app/services/constants';
import { Color } from 'cesium';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { baseLayers, overlays } from '../../config/baseLayer.js';
import { CollectionPopupComponent } from '../collections/collection-popup/collection-popup.component';
import { PopupService } from 'src/app/services/popup.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-arrowheads';
import 'leaflet-geometryutil';
import 'leaflet-polylinedecorator';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
var turf = require('@turf/turf');
var geoParse = require('wellknown');

const cesiumContainer = document.createElement('div');
cesiumContainer.id = 'cesiumGlobeContainer';
document.getElementsByTagName('body')[0].appendChild(cesiumContainer);
@Component({
  selector: 'app-previescreen',
  templateUrl: './previescreen.component.html',
  styleUrls: ['./previescreen.component.scss']
})
export class PreviescreenComponent implements OnInit, AfterViewInit, OnDestroy {
  private map: L.Map;
@ViewChild('map', { static: true }) mapContainer!: ElementRef;
  @Input() target: any = { geoJSON: '', area: 0 };
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  viewer: any = null;
  scene: any = null;
  longLatStr: string = '';
  taskTarget: any;
  taskid: any;
  taskname: any;
  coordinates: any = [];
  zoomLevel = 3;
  observationCoordinates: any = [];
  observationCoordinatesDisplay: any = [];

  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  currentUser: any;
  taskMap: any;
  cesiumToken: any;
  sensors: any;
  targetPoints: any;
  dataLoading: boolean = true;
  retask:boolean = false;
  mapFontColor = 'white';
   mapDistance = 0;
   private satelliteDataSubscription: Subscription | null = null;
   private satLayer: L.LayerGroup | null = null;
    private marker?: L.Marker; 
  private geoJsonLayer?: L.Layer;
  private drawnItems?: L.FeatureGroup;
  private latlonOverlay?: HTMLDivElement;
private latlonMoveHandler?: (e: L.LeafletMouseEvent) => void;
private latlonOutHandler?: () => void;
private satRenderer?: L.SVG;
  observationLocation: any;
  observationType: any;
  cordinateLabel: string = 'Coordinates';
  constructor(

    private dialogRef: MatDialogRef<PreviescreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private el: ElementRef, private renderer: Renderer2,
    private apiService: ApiService,
     private popupService: PopupService,
     private changDetectionRef: ChangeDetectorRef,
     private authService: AuthService,
  ) {
    this.authService.user.subscribe(user => this.currentUser = user);
    this.cesiumToken = environment.cesiumAccessToken;
    if (data['type'] === 'taskPreview') {
    this.taskid = data['taskid'];
    this.taskname = data['taskname'];
    this.taskTarget = JSON.parse(this.data['target']);
    this.sensors = data['sensors'];
    this.targetPoints = this.data['targetPoints'] ? JSON.parse(this.data['targetPoints']) : null;
    this.observationLocation = this.data['observationLocation'];

    this.coordinates = [];
    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        this.coordinates = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
      } else if (this.taskTarget?.length > 1) {
        this.taskTarget.type = this.taskTarget[0].type;
        for (const points of this.taskTarget) {
          this.coordinates.push(points.coordinates)
        }
      } else {
        this.coordinates = this.taskTarget.coordinates;
      }
    }

    if (this.observationLocation) {
      let observationCoordinatesSplit = this.observationLocation.includes(';') ? this.observationLocation.split(';') : this.observationLocation;
      this.observationCoordinatesDisplay = observationCoordinatesSplit.toString().split(',').map(Number);
      this.observationCoordinates = this.observationLocation.split(';');
      if (this.observationCoordinates.length === 1) {
        this.observationType = 'Point';
      } else {
        this.observationType = 'Polygon';
      }
      this.cordinateLabel = 'Tipping Coordinates';
    }
  }

  ngOnInit(): void {

    if (this.data['type'] === 'taskPreview') this.plotTarget();
    else if (this.data['type'] === 'permittedArea') {
      this.plotArea(this.data['user'].taskableAoi);
    }
   
  }
  
  ngAfterViewInit() {
 this.initializeMap();
  }
   private async initializeMap() {
  
      this.map = L.map(this.mapContainer.nativeElement, {
        zoom: this.zoomLevel,
        layers: [baseLayers.Sentinel], // Set the initial (default) layer
        attributionControl: false
      });
      
      var myAttrControl = L.control.attribution().addTo(this.map);
      myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
      var sentinel2Layer = L.tileLayer('https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg', {
        attribution: '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
        tileSize: 256
    }).addTo(this.map);
  
      setTimeout(() => {
        this.map.invalidateSize();
        this.changDetectionRef.detectChanges();
      }, 0);
      
      L.control
        .layers(baseLayers, overlays, {
          collapsed: false, // Optionally control whether the control is collapsed by default
          position: 'topright', // Optionally set the position of the control
        })
        .addTo(this.map);
  
        if(this.retask == false) {
  
          const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser.country}`;
    
          try {
            const response = await fetch(url);
            const data = await response.json();
    
            if (data && data.length > 0) {
              const lat = data[0].lat;
              const lon = data[0].lon;
              this.map.setView([lat, lon], 10);
            } 
          } catch (error) {
          }
        }
  
        L.Icon.Default.mergeOptions({
          iconUrl: '../../../assets/map-icons/marker-icon.png',  
          iconSize: [25, 41],                
          iconAnchor: [12, 41],              
          popupAnchor: [1, -34],               
          shadowUrl: '../../../assets/map-icons/marker-shadow.png', 
          shadowSize: [41, 41],      
          shadowAnchor: [12, 41]      
        });
  
      setTimeout(() => {
        const layersControlElement = document.querySelector(
          '.leaflet-control-layers'
        );
        if (layersControlElement) {
          const container = document.getElementsByClassName(
            'leaflet-control-layers-expanded'
          )[0];
          container?.classList.remove('leaflet-control-layers-expanded');
        }
      }, 0);
  
      
  
      this.map.on('baselayerchange', (event: any) => {
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.remove('highlight-border');
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (container) {
          container.classList.remove('leaflet-control-layers-expanded');
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
        }
        const element = document.querySelector('#homeButton');
        if (element) {
          this.renderer.setStyle(element, 'z-index', '500');
        }
        if (event.name === "Openstreetmap") {
          this.mapFontColor = 'black';
          myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
          myAttrControl.removeAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
          myAttrControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
          const elements = document.querySelectorAll('[id^="custom-div"]');
          elements.forEach((element: any) => {
            element.style.color = this.mapFontColor
          });
        } else {
          this.mapFontColor = 'white';
          myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
          myAttrControl.removeAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
          myAttrControl.addAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
          const elements = document.querySelectorAll('[id^="custom-div"]');
          elements.forEach((element: any) => {
            element.style.color = this.mapFontColor
          });
        }
      });
  
      this.map.createPane('left');
      this.map.createPane('right');
      this.map.on('baselayerchange', (e: any) => {
        this.map.off('layerremove');
        this.map.off('layeradd');
      });
      this.map.on('layeradd', (e: any) => {});
      this.map.on('layerremove', (e: any) => {
        this.map.off('layerremove');
      });
      this.initLatLonOverlay();
  
      document.querySelector('.leaflet-control-layers-toggle')?.addEventListener('click', (e) => {
        this.removeHighlight();
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.add('highlight-border');
        if(document.querySelector('.leaflet-control-layers-expanded')) {
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-48px !important')
        }
  
        const searchBtnParentEl = document.querySelector('.leaflet-geosearch-button') as HTMLElement;
        const searchInput = document.querySelector('.leaflet-geosearch-button form input') as HTMLInputElement;
        if(!searchInput.value && !searchInput.classList.contains('active')) {
          searchBtnParentEl.classList.remove('active');
        }
      })
  
      this.map.on('click', function () {
        //clearing search input
        const searchInput: any = document.querySelector('.leaflet-control-geocoder-form input');
        if(searchInput?.value) {
          searchInput.value = "";
        }
  
        let links = document.querySelectorAll('.leaflet-draw-toolbar span a');
        links.forEach((s: any) => s.classList.remove('highlight-border'));
        let homeBtn: any = document.querySelector('#homeButton');
        homeBtn.classList.remove('highlight-border');
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.remove('highlight-border');
        var controlContainer = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (
          controlContainer &&
          controlContainer.classList.contains('leaflet-control-layers-expanded')
        ) {
          controlContainer.classList.remove('leaflet-control-layers-expanded');
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
        } 
  
        const searchBtnParentEl = document.querySelector('.leaflet-geosearch-button') as HTMLElement;
        searchBtnParentEl.classList.remove('active');
        
      });
  
      const mapContainer: any = document.getElementById('map');
      const zoomDiv = document.getElementById('zoomDiv');
      mapContainer.appendChild(zoomDiv);
      this.map.removeControl(this.map.zoomControl);
      const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
      zoomControl.addTo(this.map);
      this.calculateZoomLevel();
      this.changDetectionRef.detectChanges();
      if (this.data['type'] === 'satelliteTracking')  {
      this.dataLoading = true;
      this.getSatelliteData();
    }
    }
     removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if(homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
    if(layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }
   calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

zoomtoLocation(): void {
  if (!this.map) return;
  if (this.marker && typeof (this.marker as any).getLatLng === 'function') {
    const latlng = (this.marker as any).getLatLng();
    this.map.flyTo(latlng, this.zoomLevel || 7, { 
      animate: true, 
      duration: 1.5 
    });
    return;
  }

  if (this.geoJsonLayer && typeof (this.geoJsonLayer as any).getBounds === 'function') {
    try {
      const bounds = (this.geoJsonLayer as any).getBounds();
      if (bounds?.isValid()) {
        this.map.flyToBounds(bounds, {
          padding: [50, 50],
          maxZoom: 7,
          animate: true,
          duration: 1.5
        });
        return;
      }
    } catch (e) {
    }
  }

  const dataSourceLayers = [this.satLayer, this.drawnItems];
  
  for (const layer of dataSourceLayers) {
    if (layer) {
      // For layer groups
      if (typeof (layer as any).getBounds === 'function') {
        try {
          const bounds = (layer as any).getBounds();
          if (bounds?.isValid()) {
            this.map.flyToBounds(bounds, {
              padding: [50, 50],
              maxZoom: 7,
              animate: true,
              duration: 1.5
            });
            return;
          }
        } catch (e) {
        }
      }
      // For feature groups with layers
      else if (typeof (layer as any).getLayers === 'function') {
        const layers = (layer as any).getLayers();
        if (layers && layers.length > 0) {
          const group = L.featureGroup(layers);
          const bounds = group.getBounds();
          if (bounds?.isValid()) {
            this.map.flyToBounds(bounds, {
              padding: [50, 50],
              maxZoom: 7,
              animate: true,
              duration: 1.5
            });
            return;
          }
        }
      }
    }
  }

  
  // if (this.lattitude && this.longitude) {
  //   this.map.flyTo([this.lattitude, this.longitude], this.zoomLevel || 7, {
  //     animate: true,
  //     duration: 1.5
  //   });
  //   return;
  // }

  // 5) Last resort - scan all layers on map
  const allBounds = L.latLngBounds([]);
  let foundAny = false;

  this.map.eachLayer((layer: any) => {
    if (typeof layer.getBounds === 'function') {
      try {
        const b = layer.getBounds();
        if (b?.isValid()) {
          allBounds.extend(b);
          foundAny = true;
        }
      } catch (e) {}
    } else if (typeof layer.getLatLng === 'function') {
      try {
        const ll = layer.getLatLng();
        allBounds.extend(ll);
        foundAny = true;
      } catch (e) {}
    }
  });

  if (foundAny && allBounds.isValid()) {
    this.map.flyToBounds(allBounds, {
      padding: [50, 50],
      maxZoom: 7,
      animate: true,
      duration: 1.5
    });
  } else {
    this.map.setView([0, 0], 2);
  }
}

  plotTarget() {
    let target: any,
      viewer = this.viewer;
      const isLBandIncluded = this.sensors.some(item => (item.operatorKey === OPERATORS.LBAND));
      
    if (this.taskTarget) {
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
        var bbox = turf.bbox(this.taskTarget);
        var rectangle = Cesium.Rectangle.fromDegrees(
          bbox[0],
          bbox[1],
          bbox[2],
          bbox[3]
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          name: this.taskname,
          polygon: {
            hierarchy: {
              positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
            },
            fill: false,
            height: 0,
            outlineColor: Cesium.Color.YELLOW,
            outline: true,
          },
        });
        viewer.flyTo(target, { duration: 3 });
      } else if (this.taskTarget?.length > 1) {
        this.createGeoJSONFile(this.taskTarget);
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
        const lng = fpPos[0],
          lat = fpPos[1];
        var rectangle = Cesium.Rectangle.fromDegrees(
          lng - 1,
          lat - 1,
          lng + 1,
          lat + 1
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          id: this.taskname,
          position: Cesium.Cartesian3.fromDegrees(lng, lat), //  bbPosition,
          billboard: {
            image: 'assets/images/marker-icon.png',
            show: true, // default
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 20, // default: undefined
            height: 30, // default: undefined
          },
        });
        this.defaultLL = [lng, lat];
        this.viewer.camera.flyTo(
          {
            destination: Cesium.Cartesian3.fromDegrees(lng, lat, 100000.0),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90.0),
              roll: 0.0,
            },
          },
          { duration: 3 }
        );
      }
    }


    ///observatiom
    if (this.observationCoordinates?.length > 0) {
      if (this.observationType === 'Point') {
        const [lng, lat] = this.observationCoordinates[0].split(',').map(Number);

        viewer.entities.add({
          name: 'Observation Point',
          position: Cesium.Cartesian3.fromDegrees(lng, lat),
          point: {
            pixelSize: 10,
            color: Cesium.Color.RED,
          },
          label: {
            text: '',
            show: true, // default
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 10, // default: undefined
            height: 20, // default: undefined
          },
        });
      } else if (this.observationType === 'Polygon') {
        const coords = this.observationCoordinates
          .map(c => c.split(',').map(Number))
          .flat();

        viewer.entities.add({
          name: 'Observation Line',
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(coords),
            material: Cesium.Color.RED,
          },
        });
      }
    }
  }

  drawCircles(coordinates) {
    const radius = RF_RADIUS * 1000;
    const lng = coordinates[0],
      lat = coordinates[1];

      // Create a circle entity for each point
      this.viewer.entities.add({
        name:'circles',
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        ellipse: {
          semiMajorAxis: radius,
          semiMinorAxis: radius,
          material: Color.BLUE.withAlpha(0.4)
        },
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
  }

  createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
  
  let selectData: any;
  selectData = Cesium.GeoJsonDataSource.load(geoJSON);

  selectData.then((dataSource) => {
    const entities = dataSource.entities.values;
    for (let i = 0; i < entities.length; i++) {
      const entity = entities[i];
      entity.billboard = new Cesium.BillboardGraphics({
        image: 'assets/images/marker-icon.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 30,
      });
      entity.label = new Cesium.LabelGraphics({
        text: (i + 1).toString(), // Set the label to the index + 1
        font: '14pt sans-serif',
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust the offset to position the label correctly
      });
    }

    this.viewer.flyTo(dataSource, { duration: 3 });
    this.viewer.dataSources.add(dataSource);
    this.viewer.scene.globe.depthTestAgainstTerrain = false;
  });
  }

  flyHome() {
    this.viewer.camera.flyHome(2); // take 2 seconds
  }

/** Call this after the map is created (e.g., ngAfterViewInit) */
initLatLonOverlay(): void {
  if (!this.map) return;

  // Create overlay div once
  this.latlonOverlay = document.createElement('div');
  Object.assign(this.latlonOverlay.style, {
    position: 'absolute',
    zIndex: '1000',
    right: '40px',
    bottom: '27px',
    height: '30px',
    width: 'fit-content',
    pointerEvents: 'none',
    textAlign: 'center',
    justifyContent: 'center',
    padding: '5px 4px 0 4px',
    color: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    font: '12px/20px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
    borderRadius: '4px',
    backdropFilter: 'blur(2px)',
  });

  // Append into the map container
  this.map.getContainer().appendChild(this.latlonOverlay);
  this.latlonOverlay.innerHTML = `<div style="padding:0">Move cursor on map</div>`;

  // Handlers
  this.latlonMoveHandler = (e: L.LeafletMouseEvent) => {
    const lat = e.latlng.lat;
    const lng = e.latlng.lng;
    const latDMS = this.toDMS(lat, true);
    const lngDMS = this.toDMS(lng, false);
    const text = `Lng: ${lngDMS}, Lat: ${latDMS}`;
    this.latlonOverlay!.innerHTML = `<div style="padding:0">${text}</div>`;
  };

  // When cursor leaves the map container
  this.latlonOutHandler = () => {
    if (this.latlonOverlay) {
      this.latlonOverlay.innerHTML = `<div style="padding:0">Out of Map</div>`;
    }
  };

  // Attach listeners
  this.map.on('mousemove', this.latlonMoveHandler);
  // mouseout on container (DOM), because Leaflet's 'mouseout' can fire frequently among internal layers
  this.map.getContainer().addEventListener('mouseleave', this.latlonOutHandler);
}


destroyLatLonOverlay(): void {
  if (!this.map) return;
  if (this.latlonMoveHandler) this.map.off('mousemove', this.latlonMoveHandler);
  if (this.latlonOutHandler) this.map.getContainer().removeEventListener('mouseleave', this.latlonOutHandler);
  if (this.latlonOverlay?.parentElement) this.latlonOverlay.parentElement.removeChild(this.latlonOverlay);
  this.latlonOverlay = undefined;
  this.latlonMoveHandler = undefined;
  this.latlonOutHandler = undefined;
}

/** Decimal degrees -> DMS string with hemisphere (e.g., 12°34'56.7"N) */
private toDMS(value: number, isLat: boolean): string {
  const hem = isLat ? (value >= 0 ? 'N' : 'S') : (value >= 0 ? 'E' : 'W');
  const abs = Math.abs(value);
  const deg = Math.floor(abs);
  const minFloat = (abs - deg) * 60;
  const min = Math.floor(minFloat);
  const sec = (minFloat - min) * 60;

  // Format: omit 0° or 0' only if you want; this keeps them for stability
  const d = `${deg}°`;
  const m = `${min}'`;
  const s = `${sec.toFixed(1)}"`;
  return `${d}${m}${s}${hem}`;
}


  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }

  plotArea(taskableAoi) {
    let target: any,
      viewer = this.viewer;
    for (const file of taskableAoi) {
      this.taskTarget = file.taskableAoi;
      if (this.taskTarget) {
        if (this.taskTarget.type === 'Polygon') {
          const fpPos = this.taskTarget.coordinates[0]
            .toString()
            .split(',')
            .map(Number);
          var bbox = turf.bbox(this.taskTarget);
          var rectangle = Cesium.Rectangle.fromDegrees(
            bbox[0],
            bbox[1],
            bbox[2],
            bbox[3]
          );

          const coords = Cesium.Cartesian3.fromDegreesArray(fpPos);


         const polygonPoints = this.taskTarget.coordinates[0];
          // Step 2: Find the bottom-most point (minimum latitude)
          const bottomLonLat = polygonPoints.reduce((lowest, current) => {
            return current[1] < lowest[1] ? current : lowest;
          }, polygonPoints[0]);
      
          // Step 3: Calculate dynamic vertical shift
          const latitudes = polygonPoints.map(p => p[1]);
          const maxLat = Math.max(...latitudes);
          const minLat = Math.min(...latitudes);
          const latRange = maxLat - minLat;
      
          // Use 5% of the polygon's vertical height to shift the label down
          const shiftDegrees = latRange * 0.05;
          const labelLat = bottomLonLat[1] - shiftDegrees;
      
          // Step 4: Convert to Cesium Cartesian3
          const labelPosition = Cesium.Cartesian3.fromDegrees(bottomLonLat[0], labelLat);


          Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
          target = viewer.entities.add({
            name: file.fileName,
            polygon: {
              hierarchy: {
                positions: coords,
              },
              material: Cesium.Color.ORANGERED.withAlpha(0.1),
              fill: false,
              height: 0,
              outlineColor: Cesium.Color.YELLOW,
              outline: true,
            },
            position: labelPosition, // <-- this is where position belongs
            label: {
              text: file.fileName,
              font: '12pt sans-serif',
              fillColor: Cesium.Color.WHITE,
              style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              outlineWidth: 2,
              outlineColor: Cesium.Color.BLACK,
              showBackground: true,
              backgroundColor: Cesium.Color.BLACK.withAlpha(0.5),
            }
          });
          viewer.flyTo(target, { duration: 3 });
        }
      }
    }
  }

 getSatelliteData() {
    let sensor = this.data['sensor'];
    let sensorName, sensorInfo;
    if (sensor?.key != OPERATORS.HEAD) {
      sensorName = [sensor?.name];
      sensorInfo = [{ key: sensor?.name, obfuscateName: sensor?.obfuscateName }];
    } else {
      sensorName = [sensor?.key];
      sensorInfo = [{ key: sensor?.key, obfuscateName: sensor?.obfuscateName }];
    }
    let sensorData = {};
    sensorData['sensorName'] = sensorName;
    sensorData['sensors'] = sensorInfo;
    sensorData['action'] = this.data['action'];

    if (this.data['action'] === 'projectedData') {
      let target = this.data['target'];
      sensorData['openWindow'] = moment(target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment(target.closeWindow)
        .utcOffset(0, true)
        .format();
      sensorData['target'] = JSON.stringify(geoParse(target.geoJSON));
    }

    const sensorObj = { sensorData: sensorData };
     if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
   this.satelliteDataSubscription = this.apiService.getSatelliteData(sensorObj).subscribe((res: any) => {
      if (res?.msg === 'Failed') {
        this.dataLoading = false;
        const message = 'There are no active satellites for the chosen provider at this time. Please select another.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      } else this.plotSatellitePath(res);
    });
  }

      plotSatellitePath(result: any) {
    if (!this.map) return;
  
    // clear previous layer
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
    }
  
    this.ensureSatellitePane();
    this.satLayer = L.layerGroup([], { pane: 'satellitePane' });
  
    const bounds = L.latLngBounds([]);
  
    if (Array.isArray(result) && result.length > 0) {
      for (let i = 0; i < result.length; i++) {
        const satelliteData = result[i];
        const satellite = satelliteData;
        const posArr: number[][] = Array.isArray(satellite.position) ? satellite.position : [];
        const [endLon, endLat] = posArr.length > 0
          ? [posArr[posArr.length - 1][0], posArr[posArr.length - 1][1]]
          : [satellite.longitude, satellite.latitude];
  
        const icon = L.icon({
          iconUrl: 'assets/images/satellite.png',
          iconSize: [25, 20],
          iconAnchor: [12.5, 20],
        });
        const name = (this.currentUser?.obfuscated && satellite.obfuscateName)
    ? satellite.obfuscateName
    : satellite.name;
  
    const time = satellite.time ?? '';
  
    const labelText = `<div class="satellite-label-line">${name}</div>
                     <div class="satellite-label-line">${time}</div>`;
  
        const marker = L.marker([satellite.latitude, satellite.longitude], {
          icon,
          pane: 'satellitePane',
          interactive: false,
          zIndexOffset: 1000,
        }).bindTooltip(labelText, {
          permanent: true,
          direction: 'bottom',
          offset: L.point(0, -10),
          className: 'satellite-label',
        });
  
        marker.addTo(this.satLayer);
        bounds.extend(marker.getLatLng());
  
        const color = this.getOperatorColor(this.data['sensor']?.name);
        const line = L.polyline(
          [
            [satellite.latitude, satellite.longitude],
            [endLat, endLon],
          ],
          {
            color,
            weight: 2,
            pane: 'satellitePane',
            interactive: false,
            renderer: this.satRenderer, 
          }
        ).addTo(this.satLayer);
  
        if ((L as any).polylineDecorator && (L as any).Symbol?.arrowHead) {
          const decorator = (L as any).polylineDecorator(line, {
             patterns: [
                        {
                          offset: '100%',
                          repeat: 0,
                          symbol: (L as any).Symbol.arrowHead({
                            pixelSize: 8,
                            polygon: true,
                            pathOptions: {
                              pane: 'satellitePane',
                              renderer: this.satRenderer,
                              color,
                              weight: 2,
                              fill: true,
                              fillOpacity: 1,
                              opacity: 1,
                            },
                          }),
                        },
                      ],
          });
          decorator.addTo(this.satLayer);
        }
        bounds.extend([endLat, endLon]);
      }
  
      this.satLayer.addTo(this.map);
  
      if (bounds.isValid()) {
this.map.fitBounds(bounds.pad(0.5));
 this.map.setZoom(2, { animate: false });
      }
  
      this.dataLoading = false;
    }
  }
  
  private ensureSatellitePane() {
    if (!this.map.getPane('satellitePane')) {
      const pane = this.map.createPane('satellitePane');
      pane.style.zIndex = '650';
    }
    if (!this.satRenderer) {
      this.satRenderer = L.svg({ pane: 'satellitePane' });
      this.satRenderer.addTo(this.map);
    }
  }
  
  private getOperatorColor(key: string): string {
    switch (key) {
      case OPERATORS.CAPELLA: return 'yellow';
      case OPERATORS.SATELLOGIC: return 'yellowgreen';
      case OPERATORS.UMBRA: return 'blue';
      case OPERATORS.HEAD: return 'greenyellow';
      case OPERATORS.STE: return 'blueviolet';
      case OPERATORS.AT21: return 'green';
      case OPERATORS.KOMPSAT: return 'cyan';
      case OPERATORS.USL: return 'indigo';
      case OPERATORS.ISI: return 'turquoise';
      case OPERATORS.AXELSPACE: return 'gold';
      case OPERATORS.GHG: return '#25aae0';
      case OPERATORS.ORORATECH: return '#008B8B';
      case OPERATORS.WYVERN: return 'brown';
      case OPERATORS.SPIRE: return 'plum';
      case OPERATORS.CLYDE: return '#BC8F8F';
      case OPERATORS.SYNSPECTIVE: return 'green';
      case OPERATORS.GOKTURK: return '#9ce49c';
      case OPERATORS.LBAND: return 'violet';
      case OPERATORS.ECURS:
      case OPERATORS.ECURS_L: return 'aqua';
      case OPERATORS.ESPER: return 'deeppink';
      default: return 'royalblue';
    }
  }
   ngOnDestroy(): void {
      this.map.remove();
      if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
    this.destroyLatLonOverlay()
    }
}
